import { useState, useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_SYSTEMS } from "../../../../../apis/settingsApis/access-apis/accessApis";
import { SystemKey, IntegrationType } from "../../../../../utils/enums";
export const useSystemsData = (filterObject) => {
  const [criticalSystems, setCriticalSystems] = useState([]);
  const [systemAdmins, setSystemAdmins] = useState([]);
  const [integrationTypes, setIntegrationTypes] = useState([]);

  const {
    data: criticalSystemsResponse,
    loading: loadingCriticalSystems,
    refetch: refetchCriticalSystems,
  } = useQuery(GET_SYSTEMS, {
    variables: {
      page: 1,
      limit: 1000,
      filter: filterObject,
    },
    fetchPolicy: 'cache-and-network',
  });

  const allSystems = useMemo(() => {
    const systems = criticalSystemsResponse?.getSystems?.data || [];
    // Exclude Zoho People only if it's not manual (allow manual Zoho People)
    return systems.filter((s) => {
      const isZohoPeople = s.key?.toLowerCase() === SystemKey?.ZOHO_PEOPLE;
      return !isZohoPeople || (isZohoPeople && (s.integration_type || '').toUpperCase() === IntegrationType.MANUAL);
    });
  }, [criticalSystemsResponse]);

  useEffect(() => {
    if (allSystems?.length > 0) {
      const systems = allSystems.map((r) => ({
        id: String(r.id),
        name: r.label,
        system_admin: r.system_admin || null,
        type: r.category || null,
        integration_key: r.key,
        integration_type: r.integration_type || null,
        review_cycle: r.review_cycle,
        last_reviewed_at: r.last_reviewed_at,
        created_at: r.created_at,
        is_critical: r.is_critical,
        is_review_active: r.is_review_active,
        account_label: r.account_label || null,
      }));
      setCriticalSystems(systems);
    }
  }, [allSystems]);

  useEffect(() => {
    if (allSystems?.length > 0) {
      setSystemAdmins([...new Set(allSystems.map(s => s.system_admin).filter(Boolean))].sort());
      setIntegrationTypes([...new Set(allSystems.map(s => s.integration_type).filter(Boolean))].sort());
    }
  }, [allSystems]);

  return {
    criticalSystems,
    systemAdmins,
    integrationTypes,
    loadingCriticalSystems,
    refetchCriticalSystems,
  };
};

